import styled from "styled-components";
import { useInView } from 'react-intersection-observer';
import {mq} from '../util/media';
import {useWindowSize} from '../util/viewsize'
import anime from 'animejs';

import Button from "../Button";
import LearnMoreButton from "../LearnMoreButton";
import GradientText from "../GradientText";
import SectionWrapper from "../SectionWrapper";
import SectionTitle from "../SectionTitle";

import {ReactComponent as TechrateImg } from "../../images/techrate.svg";
import {ReactComponent as LaptopImg} from "../../images/laptop.svg";
import {ReactComponent as LaptopScreenImg} from "../../images/laptop-screen.svg";
import { useEffect } from "react";


const MainText = styled.p`
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: 0.5px;
  margin: 0;

  max-width: 500px;

  svg {
    max-height: 2.75rem;
    margin-left: 1rem;

    ${mq.lt.md} {
      max-height: 1.5rem;
    }
  }


  ${mq.lt.md} {
    font-size: 15px;
  }

  ${mq.lt.sm} {
    text-align: center;
    font-size: 11px;
    max-width: 265px;
    margin-left: auto;
    margin-right: auto;

    img {
      max-height: 39px;
      margin-left: 0.5rem;

      ${mq.lt.md} {
        max-height: 20px;
      }

      ${mq.lt.sm} {
        max-height: 25px;
      }
    }
  }

  &.maintext--image-aligned {
      display: flex;
      align-items: flex-end;
      margin-top: 1rem;
      ${mq.lt.sm} {
        justify-content: center;
        flex-direction: column;
        align-items: center;
      }
      
    }
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;

  justify-content: center;

  margin-top: 24px;
  ${mq.gt.xs} {
    gap: 2rem;
    justify-content: flex-start;
  }
`

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  aspect-ratio: 664 / 657;
  /* ${mq.lt.md} {
      max-width: 20rem;
  } */

  & > svg {
    width: 100%;
    height: 100%;
    /* object-fit: contain; */


    ${mq.lt.sm} {
      max-width: 275px;
      margin: 0 auto;
    }
  }


  ${mq.gt.xs}{
      transform-origin: right center;
      transform: scale(1.2);
    }

    ${mq.gt.md}{

      transform-origin: right center;
      margin-left: -4rem;
    }

  transition: opacity 0.5s ease-in-out;
  &.hidden {
    opacity: 0;
  }
`

const ScreenWindow = styled.div`
  position: absolute;
  top: 22.1%;
  left: 18.4%;
  width: 63.4%;
  height: 40.5%;
  transform: rotate(-15deg);
  transform-origin: top left;
  overflow: hidden;

  & svg {
    width: 100%;
    height: auto;
  }
`


const InfoWrapper = styled.div`


  margin: 140px 0 114px 0;
  ${mq.lt.md} {
    margin: 45px 0;
  }
  transition: 0.7s ease-in-out;

  &.hidden {
    opacity: 0;
    transform: translateX(10%);
  }

  &.hidden-image {
    opacity: 0;
  }

  ${mq.lt.sm} {
    display: flex;
    flex-direction: column;
    align-items: center;

    & h2 {
      max-width: 12ch;
    }
  }


`

const Inner = styled.div`
  ${mq.gt.xs} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 80px;
    width: 100%;
    align-items: center;
  }

  ${mq.gt.md} {
    gap: 80px;

  }
`

const AuditImageContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-end;
  margin-top: 10px;

  ${mq.gt.sm} {
    margin-top: 0;
  }

  & svg {
    height: 32px;
    ${mq.lt.md} {
      height: 20px;
    }
  }
`



function WebApp() {

  const [textRef, textInView] = useInView({
    triggerOnce: true,
    threshold: 0.6
  });

  const [imageRef, imageInView] = useInView({
    triggerOnce: true,
    threshold: 0.6
  });

  useEffect (() => {

    var imageTL = anime.timeline({
      easing: 'easeInOutQuad',
      autoplay: false,
      loop: false
    });

    imageTL.add({
      targets: '.anime-svg--laptop',
      opacity: [0, 1],
      translateX: ['-5%', 0],
      easing: 'easeInOutQuad',
    })



    if (imageInView) {
      imageTL.play();
    }
  }, [imageInView])

  useEffect (() => {
    var textTL = anime.timeline({
      easing: 'easeInOutQuad',
      autoplay: false,
      loop: false
    });

    textTL.add({
      targets: '.anime--info--webapp',
      opacity: [0, 1],
      translateX: ['5%', 0],
      easing: 'easeInOutQuad',
    })

    // anime({
    //   targets: '.anime-svg--laptop-screen',
    //   translateY: ['0', '-50%'],
    //   easing: 'easeInOutQuad',
    //   direction: 'alternate',
    //   loop: true,
    //   duration: 7000,
    // })


    if (textInView) {
      textTL.play()
    }
  }, [textInView])

  const [width] = useWindowSize();

  return(
    <SectionWrapper smaller>

        <Inner>

          <div className="anime-svg--laptop" >
            <ImageContainer ref={imageRef}>
              <LaptopImg />
              <ScreenWindow>
                <LaptopScreenImg className="anime-svg--laptop-screen" />
              </ScreenWindow>
            </ImageContainer>
          </div>

          <InfoWrapper ref={textRef} className="anime--info--webapp">
            <SectionTitle>Near Treasury offers a <GradientText to="right" color1="#D976C4" color2="#CC62F0">genius</GradientText> <GradientText to="right" color1="#E487A0" color2="#D46ED7">WebApp</GradientText></SectionTitle>          
            {width < 710 && (
              <MainText>
                Built simple and secure.<br/> Enjoy the most valuable ecosystem in the world.
              </MainText>
            )}

            {width >= 710 && (
              <MainText>
                Built simple and secure - Enjoy the most valuable ecosystem in the world.
              </MainText>
            )}
            

            <MainText className="maintext--image-aligned">
              <span>
                Audit in Progress by:
              </span>
              <AuditImageContainer>
                <TechrateImg />
              </AuditImageContainer>
            </MainText>
            <ButtonContainer>
              <LearnMoreButton>Learn More</LearnMoreButton>
              <Button link="/webapp" type="webapp">WebApp</Button>
            </ButtonContainer>
          </InfoWrapper>

          
        </Inner>

    </SectionWrapper>

  )
}

export default WebApp;